import React from 'react';
import { Button, Calendar, Grid, ICalendarValue, SpaceWrapper } from 'ui-toolkit';
import styled from 'styled-components';
import { useFormik } from 'formik';
import * as yup from 'yup';

const StyledModalGrid = styled(Grid)`
  justify-items: center;
`;

interface IEditDateInlineProps {
  value: string | null;
  validationSchema: any;
  onUpdateOrder: (value: string | null) => Promise<void>;
  onClose: () => void;
  isRequired?: boolean;
  highlightDate?: 'today' | string;
  'data-test-id'?: string;
}

export const EditDateInline: React.FC<IEditDateInlineProps> = ({
  value,
  validationSchema,
  onUpdateOrder,
  onClose,
  isRequired,
  highlightDate,
  'data-test-id': dataTestId,
}) => {
  const formik = useFormik({
    initialValues: {
      value,
    },
    validationSchema: yup.object({ value: validationSchema }),
    onSubmit: async (values) => {
      await onUpdateOrder(values.value);
      onClose();
    },
  });

  const onValueChange = (value: ICalendarValue) => {
    formik.setFieldValue('value', value.value);
    formik.setFieldTouched('value');
  };

  const onClearDate = () => {
    formik.setFieldValue('value', null);
    formik.setFieldTouched('value');
    formik.submitForm();
  };

  return (
    <SpaceWrapper>
      <form>
        <StyledModalGrid>
          <Calendar
            inputDate={formik.values.value}
            inCard={false}
            onChange={onValueChange}
            highlightDate={highlightDate}
          />
          {isRequired ? null : (
            <Button intent={'ghost'} type={'button'} onClick={() => onClearDate()}>
              Clear Date
            </Button>
          )}
          <Button intent={'primary'} type={'button'} data-test-id={dataTestId} onClick={() => formik.submitForm()}>
            Update Order
          </Button>
        </StyledModalGrid>
      </form>
    </SpaceWrapper>
  );
};
